import { useLocation } from 'react-router-dom';
import { AppRoutes } from '@/app/routes';
import { RouteFallback } from '@/components/RouteFallback';
import { useAuthController } from '@/features/auth/controller/auth.controller';
import { isNativePlatform } from '@/lib/platform';
import { NativeTabBar } from './NativeTabBar';
import { isTabBarShown } from './tabBarShown';

// Drawn without the tabs once loaded, so not while loading either.
const WITHOUT_TABS: readonly string[] = [
  AppRoutes.auth.login,
  AppRoutes.auth.register,
  AppRoutes.auth.join,
  '/auth',
  AppRoutes.dashboard.verifyEmail,
  AppRoutes.legal.mentions,
  AppRoutes.legal.privacy,
  AppRoutes.legal.cgu,
  AppRoutes.legal.cgv,
  AppRoutes.match.input,
];

/**
 * While a screen's code loads. In the app on a phone, the status bar strip and the tabs stay
 * and only the content waits (VOL-343): a full-screen « Chargement… » made every first visit
 * of a screen, cold start included, look like a page reload.
 */
export function AppRouteFallback() {
  const { pathname } = useLocation();
  const signedIn = useAuthController((s) => Boolean(s.user));
  const withoutTabs = WITHOUT_TABS.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));

  if (!isNativePlatform() || !signedIn || withoutTabs || !isTabBarShown()) return <RouteFallback />;

  return (
    <div className="h-dvh flex flex-col bg-slate-50 pb-[calc(3.5rem+var(--safe-area-inset-bottom,0px))]">
      <div
        aria-hidden="true"
        data-testid="status-bar-inset"
        className="bg-action h-[var(--safe-area-inset-top,env(safe-area-inset-top,0px))]"
      />
      <RouteFallback className="flex-1" />
      <NativeTabBar />
    </div>
  );
}
